<spinner></spinner>
<toaster-container [toasterconfig]="toasterconfig"></toaster-container>
<router-outlet></router-outlet>